import { Component} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CountryService } from '../../../services';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

// import {DialogService} from 'primeng/dynamicdialog';
 
@Component({
  selector: 'app-country-view-modal',
  templateUrl: './country-view-modal.component.html',
})
export class CountryViewModalComponent {

  countryDetail: any;
  idFromParent: number;

  constructor(
    private spinner: NgxSpinnerService,
    private countryService:CountryService,
    // private dialogService: DialogService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig
  ) 
  {
    this.idFromParent = config.data.id;
  }

  ngOnInit(): void {
    this.getCountryDetails();
  }

// config.data.employee
  getCountryDetails()
  {
    this.countryService.getCountryDetail(this.idFromParent).subscribe((data: any) => {
    // this.countryService.getCountryDetail(1).subscribe((data: any) => {
      this.countryDetail = data;
      console.log('this.countryDetail');
      console.log(this.countryDetail);
     });
  }





}
